<template>
    <div class="advantage main_width main_color m_0">
        <div class="title">更多核心优势助力商家运营</div>
        <div class="advantage_nav">
            <div v-for="(item, index) in list" :key="index" :class="item.type === type ? 'active' : ''" @click="clickTab(item.type)">{{ item.title }}</div>
        </div>
        <div v-for="(item, index) in list" :key="index">
            <div class="content" v-if="item.type === type"> 
                <div>{{ item.content }}</div>
                <img 
                    :src="item.img" 
                    alt="" 
                    :class="[
                        { 'advantage1': item.type === 1 },
                        { 'advantage2': item.type === 2 },
                        { 'advantage3': item.type === 3 },
                        { 'advantage4': item.type === 4 }
                    ]"
                >
            </div>
        </div>
    </div>
</template>
<script>
import advantage1 from '../../../static/images2/advantage1.webp'
import advantage2 from '../../../static/images2/advantage2.webp'
import advantage3 from '../../../static/images2/advantage3.webp'
import advantage4 from '../../../static/images2/advantage4.webp'
export default {
    name: 'advantage',
    data() {
        return {
            type: 1,
            list: [
                {   
                    type: 1,
                    title: 'AI客服管家',
                    content: '7*24小时自动秒回+报价甩链接，让你解放双手随时随地完成交易',
                    img: advantage1
                },
                {   
                    type: 2,
                    title: '专业拍摄支持',
                    content: '助力打造企业高端形象，让企业提升品牌力。自动生成带货视频 同步到抖音、快手、微信视频号，精准引流。',
                    img: advantage2
                },
                {   
                    type: 3,
                    title: '海量流量扶持',
                    content: '拥有3500万用户汽修宝APP的流量支持，优质用户流助力商家 实现快速增长',
                    img: advantage3
                },
                {   
                    type: 4,
                    title: '多渠道一键铺货',
                    content: '商品一键同步到各大交易平台',
                    img: advantage4
                },
            ]
        }
    },
    methods: {
        clickTab(type) {
            this.type = type
        }
    }
}
</script>
<style lang="less" scoped>
@import "../../assets/style/utils.less";
div {
    box-sizing: border-box;
}
.advantage {
    text-align: center;
    font-size: .px2vw(16)[@result];
    margin-bottom: .px2vw(64)[@result];
    .title {
        font-weight: 700;
        font-size: .px2vw(32)[@result];
        margin: .px2vw(56)[@result] auto .px2vw(24)[@result];
    }
    .advantage_nav {
        display: flex;
        align-items: center;
        justify-content: center;
        height: .px2vw(46)[@result];
        font-weight: 500;
        margin-bottom: .px2vw(64)[@result];
        & > div {
            margin: 0 .px2vw(28)[@result];
            cursor: pointer;
        }
        .active {
            color: #165DFF;
            position: relative;

            &:after {
                width: 100%;
                height: .px2vw(2)[@result];
                background: #165DFF;
                content: '';
                position: absolute;
                bottom: .px2vw(-10)[@result];
                left: 50%;
                transform: translate(-50%, 0);
            }
        }
    }
    .content {
        height: .px2vw(550)[@result];
        & > div {
            margin: 0 auto;
            width: .px2vw(460)[@result];
            line-height: .px2vw(24)[@result];
        }
    }
    .advantage1 {
        width: .px2vw(933)[@result];
        height: .px2vw(317)[@result];
        margin-top: .px2vw(48)[@result];
    }
    .advantage2 {
        width: .px2vw(979)[@result];
        height: .px2vw(392)[@result];
        margin: .px2vw(31)[@result] .px2vw(42)[@result] 0 .px2vw(259)[@result];
    }
    .advantage3 {
        width: .px2vw(981)[@result];
        height: .px2vw(363)[@result];
        margin-top: .px2vw(35)[@result];
    }
    .advantage4 {
        width: .px2vw(590)[@result];
        height: .px2vw(234)[@result];
        margin-top: .px2vw(24)[@result];
    }

}
@media screen and (max-width: 900px) {
    div {
        box-sizing: border-box;
    }
    .advantage {
        font-size: .h5px2vw(24)[@result];
        line-height: .h5px2vw(32)[@result];
        // margin-bottom: .h5px2vw(64)[@result];
        .title {
            font-size: .h5px2vw(32)[@result];
            margin: .h5px2vw(56)[@result] auto .h5px2vw(24)[@result];
        }
        .advantage_nav {
            height: .h5px2vw(92)[@result];
            margin-bottom: .h5px2vw(40)[@result];
            font-size: .h5px2vw(28)[@result];
            overflow-x: auto;
            flex-wrap: nowrap;
            justify-content: flex-start;
            scrollbar-width: none;
            -ms-overflow-style: none;
            &::-webkit-scrollbar {
                display: none;
            }
            & > div {
                margin: 0 .h5px2vw(24)[@result];
                white-space: nowrap;
            }
            .active {
                &:after {
                    height: .h5px2vw(2)[@result];
                    bottom: .h5px2vw(-28)[@result];
                }
            }
        }
        .content {
            // height: .h5px2vw(400)[@result];
            height: auto;
            & > div {
                margin: 0;
                padding: 0 .h5px2vw(71)[@result];
                width: 100%;
                line-height: .h5px2vw(32)[@result];
            }
        }
        .advantage1 {
            width: .h5px2vw(646)[@result];
            height: .h5px2vw(220)[@result];
            padding: .h5px2vw(24)[@result] .h5px2vw(52)[@result] .h5px2vw(71)[@result];
            margin: 0;
        }
        .advantage2 {
            width: .h5px2vw(562)[@result];
            height: .h5px2vw(226)[@result];
            padding: .h5px2vw(24)[@result] .h5px2vw(72)[@result] .h5px2vw(65)[@result] .h5px2vw(116)[@result];
            margin: 0;
        }
        .advantage3 {
            width: .h5px2vw(570)[@result];
            height: .h5px2vw(211)[@result];
            padding: .h5px2vw(24)[@result] .h5px2vw(90)[@result] .h5px2vw(80)[@result] .h5px2vw(90)[@result];
            margin: 0;
        }
        .advantage4 {
            width: .h5px2vw(590)[@result];
            height: .h5px2vw(234)[@result];
            padding: .h5px2vw(24)[@result] .h5px2vw(80)[@result] .h5px2vw(89)[@result] .h5px2vw(80)[@result];
            margin: 0;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/cloudWarehouse/advantage.vue